import React from "react";

import HexAuthWrapper from "../../components/HexAuthWrapper";
import WithdrawalDetailRoute from "../../features/finance/WithdrawalDetailRoute";

const FinanceWithdrawalDetailPage = () => (
  <div className="finance-withdrawal-detail-page full-bleed">
    <HexAuthWrapper>
      <WithdrawalDetailRoute />
    </HexAuthWrapper>
  </div>
);

export default FinanceWithdrawalDetailPage;
